<template>
	<div class="initial-form">
		<div class="field">
			<label for="unit">{{$t('unit')}}:</label><br>
			<v-select 
				id="unit" v-model="form.unit" :options="form.unitOptions"
				label="NMFILIAL" @input="onChangeUnit()"
			></v-select>
		</div>
		<div class="field">
			<label for="service">{{$t('service')}}:</label><br>
			<v-select 
				id="service" v-model="form.service" :options="form.serviceOptions"
				label="NMSERVICO" :disabled="form.disableService"
			></v-select>
		</div>
		<div class="field">
			<label for="contract">{{$t('type_contract')}}:</label><br>
			<v-select 
				id="contract" v-model="form.contract" :options="form.contractOptions"
				label="contractName"
			></v-select>
		</div>
		<div class="field">
			<label for="date">{{$t('date')}}:</label><br>
			<input 
				id="date"
				type="month" v-model="form.date"
			/>
		</div>
		<div class="action">
			<input
				type="button"
				class="button"
				:value="$t('save')"
				@click="saveParams"
			/>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import InitialFormController from '../controllers/InitialFormController'
import { t } from 'i18next';
export default {
	name: "InitialForm",
	components:{
		'v-select':vSelect
	},
	data() {
		return {
			form:{
				unit:null,
				service:null,
				contract:null,
				date:null,
				unitOptions:[],
				serviceOptions:[],
				contractOptions:[
					{
						contractType: 'CONTRATO', contractName :t('contract'),
					},
					{
						contractType: 'PLANEJADO', contractName:t('planned')
					}
				],
				disableService:true,
			}
		};
	},
	methods: {
		saveParams: function(){
			InitialFormController.saveParams(this.form, this);
		},
		getUnitData: function(){
			InitialFormController.getUnitData(this.form);
		},
		getServiceData: function(){
			InitialFormController.getServiceData(this.form);
		},
		onChangeUnit: function(){
			if(this.form.unit && this.form.unit.CDFILIAL){
				this.getServiceData();
				this.form.disableService = false;
			} else {
				this.form.service = null;
				this.form.disableService = true;
			}
		}
	},
	mounted(){
		this.getUnitData();
	}
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.initial-form{
	width: calc(100% - 30px);
	margin: 25px;
	margin-bottom: 30px;
	height: auto;

	.field{
		display: inline-block;
		margin: 10px;
		text-align: left;
		font-size: .9rem;
		width: calc(100% - 45px);

		input{
			padding: 5px;
			border: 1px solid #BDBDBD;
			box-sizing: border-box;
			border-radius: 4px;
			width: 100%;

			&.input-label{
				border: none;
				border-bottom: 1px solid #BDBDBD;
				border-radius: 0;
			}
		}

		&.half{
			width: calc(50% - 35px);
		}
	}

	.action{
		display: inline-block;
		margin: 10px;
		text-align: left;
		font-size: .9rem;
		width: calc(100% - 45px);
	}
}
</style>